<template>
  <div class="selection-container">
    <div class="title-btn">
      <slot></slot>
    </div>
    <div v-on:click="$emit('input', !value)"
        :class="value ? 'selection-btn isActive' : 'selection-btn'">
    </div>
  </div>
</template>

<script>
export default {
  name: 'selection-btn',
  props: ['value']
}
</script>
<style>
.title-btn{
  float: left;
  font-size: 16px;
  margin-right: 10px;
  color: #64696c;
}
.selection-btn{
  float: left;
  cursor: pointer;
  width: 65px;
  height: 25px;
  position:relative;
  border-radius: 4px;
  padding-top:2px;
  background-color:#a3a3a3;
  -webkit-transition: background-color .5s;
  transition: background-color .5s;
}
.selection-btn::before{
  content: 'NÃO';
  color: #fff;
  padding-left: 28px;
  display: block;
  position:absolute;
  height: 100%;
  -webkit-transition: transform .5s;
  transition: transform .5s;
}
.selection-btn.isActive{
  background:#5ebc61;
}
.selection-btn.isActive::before{
    content: 'SIM';
    padding-left: 8px;
}
.selection-btn::after{
  content: ' ';
  background-color: #fff;
  padding-left: 10px;
  display: block;
  height: 20px;
  width: 20px;
  border-radius:4px;
  transform: translate(5px);
  box-shadow: 0 0 2px #848484;
  -webkit-transition: transform .3s;
  transition: transform .3s;
}
.selection-btn.isActive::after{
  transform: translate(40px);
}
</style>



// WEBPACK FOOTER //
// SelectionBtn.vue?59b760f1